import { TableCell, TableHead, TableRow } from '@material-ui/core'

const Column = (props) => {
  const { uischema, tableColumn = [] } = props
  const { rowPadding, headerBold } = uischema
  const style = {
    padding: rowPadding,
    cursor: 'default',
    fontWeight: headerBold ? 'bold' : 'normal',
  }
  return tableColumn.map((column) => {
    let { title, textAlign = 'left' } = column
    return (
      <TableCell style={style} align={textAlign}>
        {title}
      </TableCell>
    )
  })
}

const MTableHead = (props) => {
  const { uischema, showAction } = props
  const { headerColor, headerBold } = uischema
  const style = {
    padding: uischema.rowPadding,
    cursor: 'default',
    fontWeight: headerBold ? 'bold' : 'normal',
  }

  return (
    <TableHead style={{ backgroundColor: headerColor ?? '#f5f5f5' }}>
      <TableRow>
        {showAction && (
          <TableCell style={style} align="center">
            Actions
          </TableCell>
        )}
        <Column {...props} />
      </TableRow>
    </TableHead>
  )
}

export default MTableHead
